import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useFormSectionIds } from '../FormSection.Context/FormSection.Context.es.js';

const FormSectionRow = ({ children, className })=>{
    const { ids } = useFormSectionIds();
    const { titleId, descriptionId } = ids;
    return jsx("div", {
        className: classNames('row', className),
        role: "group",
        ...titleId && {
            'aria-labelledby': titleId
        },
        ...descriptionId && {
            'aria-describedby': descriptionId
        },
        children: children
    });
};
FormSectionRow.displayName = 'FormSection.Row';

export { FormSectionRow };
//# sourceMappingURL=FormSection.Row.es.js.map
